import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect} from 'react-redux-firebase'
import ProjectHeader from './ProjectHeader'

const enhance = compose(
  firebaseConnect(
    () => [
      'profile'
    ]
  ),
  connect(
    ({ firebase: { profile } }) => ({
      profile
    })
  )
)

export default enhance(ProjectHeader)


// WEBPACK FOOTER //
// ./src/components/ProjectHeader/ProjectHeaderContainer.js